import { render } from "./Trazabilidad.vue?vue&type=template&id=dce0b692&scoped=true"
import script from "./Trazabilidad.vue?vue&type=script&lang=js"
export * from "./Trazabilidad.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Trazabilidad.vue?vue&type=style&index=1&id=dce0b692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce0b692"]])

export default __exports__